var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fail-network"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.errorPage}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.errorTip))])])}
var staticRenderFns = []

export { render, staticRenderFns }